module.exports = __webpack_public_path__ + "static/media/building7.9d293109.svg";